var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4646_1571)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0.333984)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4646_1571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.60388 16.5992H16.4482C16.9189 16.5992 17.323 16.3641 17.5581 15.9569C17.7931 15.5491 17.7931 15.0827 17.5581 14.6749L11.135 3.55786C10.8999 3.15068 10.4965 2.91748 10.0251 2.91748C9.55369 2.91748 9.15026 3.15068 8.91519 3.55786L2.49398 14.6756C2.25766 15.0834 2.25766 15.5504 2.49398 15.9576C2.72905 16.3647 3.13373 16.5992 3.6045 16.5992H3.60388Z",
    fill: "#007CC2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833984,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 3.5,
    stroke: "#F9F8FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4646_1571"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4646_1571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4176,
    height: 13.6817,
    fill: "white",
    transform: "matrix(-1 0 0 1 17.7344 2.91748)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarminIcon);
export default __webpack_public_path__ + "static/media/garmin-icon.76667d753924012781ede04901d863a7.svg";
export { ForwardRef as ReactComponent };